import React, {FC, ReactNode} from 'react';

import {Dropdown} from '@optimaxdev/design-system';
import {OptionType} from '@optimaxdev/design-system/dist/types/components/prescriptionTableEditor/type';

export type PropsType = {
    name: string;
    value?: string | number;
    error?: boolean | string;
    success?: boolean;
    label?: string;
    onChange: (value: ReactNode) => void;
    options: OptionType[];
};

/**
 * Component for controlled select input which uses Design System
 */
export const Select: FC<PropsType> = ({error, label, name, onChange, options, success, value}) => (
    <Dropdown
        error={error}
        isError={Boolean(error)}
        isSuccess={success}
        label={label}
        name={name}
        onClick={newValue => onChange(String(newValue))}
        options={options}
        selectedValue={value}
        isWithLabel
    />
);
